"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'company.preview.title': '公司详情',
    'company.preview.failedToLoad': '加载公司信息失败',
    'company.preview.noCompany': '无可用的公司信息',
    'company.preview.section.basic_info': '基本信息',
    'company.preview.section.status': '状态',
    'company.preview.section.location': '位置',
    'company.preview.section.additional': '附加信息',
};
